function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "shape",
  fill: "#A4B72B",
  d: "M15.838 6.245c1.03 0 1.417-.935.914-1.947 2.295 1.306 4.863 4.84 2.295 7.083-2.117 1.85-4.316.872-6.082-1.122-1.16-1.31-4.83-2.25-4.83.48 0 1.505 1.055 2.372 2.564 2.648-.402-.276-1.18-1.258-.402-2.208.932-1.14 2.957 1.163 4.426 1.932 1.733.907 3.54-.152 4.53.066 3.125.69 1.978 6.136-2.797 5.468-2.259-.316-3.604-.841-4.485 0-1.089 1.038 1.383 2.24 2.28 2.24-1.875.639-7.185-1.5-4.832-3.727.633-.599 1.256-.839 1.765-.826 0 1.169 1.8.913 2.58.63 1.713-.619 1.194-2.534-.448-2.944-2.04-.508-3.187 3.329-7.748 1.856C3.832 15.314 3 13.954 3 12.665c0-1.287.848-2.072 1.25-2.624-.33-2.702.559-4.607 1.906-5.742 1.848-1.557 5.815-1.904 7.114.022.36.532 1.133 1.925 2.568 1.925Z"
});

var SvgChemtech = function SvgChemtech(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: 18,
    height: 18,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChemtech, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Chemtech.46da0bda.svg";
export { ForwardRef as ReactComponent };